"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.geoPointFieldFactory = void 0;
const geo_point_1 = require("../geo-point");
const errors_1 = require("../errors");
const base_1 = require("./base");
function geoPointFieldFactory(options) {
    options.checkType = (value) => {
        if (!(value instanceof geo_point_1.GeoPoint)) {
            throw new errors_1.ValidationError(`Field ${options.name} must be a valid GeoPoint`);
        }
    };
    const _a = base_1.baseFieldFactory(options), { getDefault } = _a, rest = __rest(_a, ["getDefault"]);
    function from(value) {
        if (value === undefined || value === null) {
            return getDefault();
        }
        if (value.latitude > 90 || value.latitude < -90) {
            throw new errors_1.ParseError('Latitude must be between -90 and 90');
        }
        if (value.longitude > 180 || value.longitude < -180) {
            throw new errors_1.ParseError('Longitude must be between -180 and 180');
        }
        return new geo_point_1.GeoPoint(value.latitude, value.longitude);
    }
    function to(value) {
        return value === undefined
            ? undefined
            : ((value === null || value === void 0 ? void 0 : value.serialize()) || undefined);
    }
    return Object.assign(Object.assign({}, rest), { getDefault, fromDb: from, fromApi: from, toDb: to, toApi: to });
}
exports.geoPointFieldFactory = geoPointFieldFactory;
//# sourceMappingURL=geo-point.js.map